import Loader from "components/shared/loader";
import { parallelItemChangeModalTitle } from "helpers/bid";
import { forwardingOrderChangeBehavioursEnum, parallelPointBehaviorsEnum } from "helpers/enums";
import React, { useState } from "react";
import { deleteBidItemChange } from "sources/bidItemChanges";
import {
    checkForwardingOrderCarHasChanged,
    checkItemsBeforeParallelPoint,
    deleteItemChangePoint,
} from "sources/books/bids";

const Confirm = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const {
        params: { itemType, ...params },
        hasParallelBidId,
        shiftCar,
        bid,
        add,
        back,
        getItem,
    } = props;
    const checkAndDelete = () => {
        const promises = [];
        if (hasParallelBidId && !props.firstBidPointEntered) {
            promises.push(() =>
                checkItemsBeforeParallelPoint({ bidId: params.bidId, pointIdToDelete: params.id }).then(
                    ({ willBeChanged, parallelBidId, car, driver, trailer }) => {
                        return new Promise((resolve) => {
                            if (willBeChanged) {
                                add({
                                    name: "parallelBidChange",
                                    windowMod: "sm",
                                    title: parallelItemChangeModalTitle(car, driver, trailer),
                                    parallelBidId,
                                    withoutEscClose: true,
                                    actions: {
                                        update: () =>
                                            resolve({ parallelPointBehavior: parallelPointBehaviorsEnum.Update }),
                                        delete: () =>
                                            resolve({ parallelPointBehavior: parallelPointBehaviorsEnum.Delete }),
                                        cancel: () => resolve(false),
                                    },
                                });
                            } else {
                                return resolve(params);
                            }
                        });
                    },
                ),
            );
        }
        if (shiftCar && bid.forwardingOrder) {
            promises.push(() =>
                checkForwardingOrderCarHasChanged({
                    bidId: params.bidId,
                    pointIdToDelete: params.id,
                }).then(({ willBeChanged }) => {
                    return new Promise((resolve) => {
                        if (willBeChanged) {
                            add({
                                name: "forwardingOrderCarChange",
                                windowMod: "sm",
                                title: "Обратите внимание",
                                withoutEscClose: true,
                                actions: {
                                    update: () =>
                                        resolve({
                                            forwardingOrderCarChangeBehaviour:
                                                forwardingOrderChangeBehavioursEnum.Update,
                                        }),
                                    delete: () =>
                                        resolve({
                                            forwardingOrderCarChangeBehaviour:
                                                forwardingOrderChangeBehavioursEnum.Delete,
                                        }),
                                    cancel: () => resolve(false),
                                },
                            });
                        } else {
                            resolve({});
                        }
                    });
                }),
            );
        }
        if (promises.length > 0) {
            const extraOptionsArr = [];
            const promisesSeries = async () => {
                for (let i = 0; i < promises.length; i++) {
                    const data = await promises[i]();
                    extraOptionsArr.push(data);
                }
            };
            return promisesSeries().then(() => {
                if (extraOptionsArr.some((item) => !item)) {
                    return setIsLoading(false);
                }
                return deleteItemChangePoint({
                    ...params,
                    ...extraOptionsArr.reduce((acc, item) => ({ ...acc, ...item }), {}),
                });
            });
        } else {
            return deleteItemChangePoint(params);
        }
    };
    const submitData = () => {
        setIsLoading(true);
        (itemType === "plan" ? checkAndDelete() : deleteBidItemChange(params)).then((isSuccessAction) => {
            if (isSuccessAction) {
                getItem().then(back);
            }
        });
    };
    return (
        <>
            {isLoading ? (
                <Loader />
            ) : (
                <>
                    <div className="modal-window__body">Вы уверены, что хотите удалить составляющую заявки?</div>
                    <div className="modal-window__footer">
                        <div className="btn btn-secondary btn-sm modal-window__footer-action" onClick={back}>
                            Нет
                        </div>
                        <div className="btn btn-brand btn-sm modal-window__footer-action" onClick={submitData}>
                            Да
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

export default Confirm;
